export enum FLOW_TYPE {

  SINGLE_RECIPIENT = 1,
  MULTIPLE_RECIPIENT = 2,
  MULTIPLE_RECIPIENT_DYNAMIC = 3,

}
